<template>
<div class="collection-detail" v-cloak>
  <!-- 微信认证组件 -->
  <wxAuth :share="share"></wxAuth>
  <div class="home-header">
    <!-- title -->
    <headers :params="hraderP"></headers>
  </div>
  <img :src="detailData.pic" alt="" :class="['top-banner',{'app':isApp}]">
  <div :class="['detail-warp',{'app':isApp}]">
    <div class="detail-name detail-long" v-if="detailData.name.length > 15">
      <p>{{detailData.name}}</p>
    </div>
    <div class="detail-name" v-else>
      {{detailData.name}}
    </div>
  </div>
  <div class="detail-count">
    <p class="count-left"></p>
    <p class="count-num">共{{detailData.count}}套方案</p>
    <p class="count-right"></p>
  </div>
  <!-- 方案合集列表 -->
  <div v-show="!noData && list.length > 0">
    <van-list
      v-model="loading"
      :finished="finished"
      finished-text="没有更多了"
      :offset="80"
      @load="onLoad"
    >
      <div class="list-content">
        <van-row class="list-item" v-for="(item, index) of list" :key="index">
          <router-link :to="`/solutions/detail/${item.solutionId}.html`">
            <div class="main-txt">
              <p class="title">{{item.solutionName}}</p>
              <p class="description">{{item.description}}</p>
              <div class="view-count">
                <p class="view-left"><img src="../../assets/images/hjuser.png" alt=""><span>{{item.userName}}</span></p>
                <p class="view-right"><img src="../../assets/images/readicon.png" alt=""><span>{{item.pageView}}浏览</span></p>
              </div>
            </div>
          </router-link>
        </van-row>
      </div>
    </van-list>
  </div>
  <noResult v-show="noData && list.length < 0 && list.length == 0" :noResultData="noResultData" @toListSelf="toListSelf"></noResult>
  <toTopCollection></toTopCollection>
  <router-link to="/index.html"><img src="../../assets/images/hjinexenter.png" alt="" class="to-index"></router-link>
  <div class="flooter-btn">
    <a href="/demand/add.html"><p class="btn">提交需求  专人跟进</p></a>
  </div>
</div>
</template>

<script>
import { isMobile } from '@/utils/common'
import { getCMSData } from '@/api/common'
import headers from '@/components/headers'
import wxAuth from '@/components/wxAuth'
import { collectionDetail, collectionSolutionsList } from '@/api/collection/collection'
import noResult from '@/components/noResult'
import toTopCollection from '@/components/toTopCollection'
export default {
  name: 'collection-list',
  components: { headers, wxAuth, noResult, toTopCollection },
  data () {
    return {
      share: {
        title: '解决方案馆',
        desc: '智能化产品方案,产品方案,系统方案,弱电设备方案,厂商方案,产品供应商设计方案,弱电设计方案,热门方案,规划设计方案,顶层设计方案,系统解决方案,集成商方案,招标方案,投标方案,深化设计方案,施工方案',
        imgUrl: 'https://image01.homedo.com/Files/Images/cms/www/20171225/4970465306687879653_pic1.jpg',
        url: window.location.href.split('#')[0]
      },
      hraderP: {
        title: '',
        lefticon: true
      },
      id: 0,
      loading: false,
      finished: false,
      noData: false,
      noResultData: {
        typeName: '方案',
        callback: 'callback'
      },
      paramsData: {
        current: 1,
        size: 10
      },
      list: [],
      detailData: {
        name: ''
      },
      isApp: true
    }
  },
  created () {
    this.id = this.$route.query.id
    this.getDetailData()
    this.getData()
    this.isApp = !!(($HMD$.rNavigator && ($HMD$.rNavigator.toLowerCase() === 'ios' || $HMD$.rNavigator.toLowerCase() === 'android')))
    if (!isMobile()) {
      window.location.href = `${process.env.PC_SOLUTION_URL || '//solution.homedo.com/'}/selection/${this.id}.html`
    }
  },
  methods: {
    getDetailData () {
      collectionDetail(this.id).then(result => {
        this.loading = false
        if (result.status !== 200) {
          return false
        }
        if (result.data.respCode !== '0000') {
          return false
        }
        this.detailData = result.data.data
        this.hraderP.title = this.detailData.name || '方案合集详情页'
        document.title = this.hraderP.title
        // eslint-disable-next-line no-undef
        if ($HMD$.rNavigator === 'ios' || $HMD$.rNavigator === 'android') {
          // eslint-disable-next-line no-undef
          $HMD$.M.sendApp({
            name: 'changetitle',
            value: this.hraderP.title
          })
        }
        this.getCMSData()
      }).catch(() => {
        this.loading = false
      })
    },
    getCMSData () {
      this.share.title = this.detailData.name
      this.share.desc = this.detailData.description
      getCMSData().then((res) => {
        if (res.data && res.data.respCode === '0000') {
          this.CMSData = res.data.data || {}
          if (this.CMSData.indexWechatShare) {
            this.share.imgUrl = this.CMSData.collectionDetail.imgUrl
          }
        }
      })
    },
    toListSelf () {
      this.getData()
    },
    onLoad () {
      // 调用查询接口
      collectionSolutionsList(this.id, this.paramsData).then(result => {
        if (result.status !== 200) {
          this.loading = false
          this.finished = true
          return false
        }
        if (result.data.respCode !== '0000') {
          this.loading = false
          this.finished = true
          return false
        }
        this.paramsData.current += 1
        this.list = this.list.concat(result.data.data.records)
        this.loading = false
        if (this.list.length === result.data.data.total || this.list.length > result.data.data.total) {
          this.finished = true
        }
      }).catch(() => {
        this.loading = false
        this.paramsData.total = 0
      })
    },
    getData () {
      this.paramsData.current = 1
      this.paramsData.size = 10
      this.finished = false
      this.noData = false
      this.onLoad()
    }
  }
}
</script>

<style scoped lang="scss">
    [v-cloak] {
        display: none;
    }
  .collection-detail{
    background-color: #F5F5F5;
    position: relative;
    .detail-warp{
        width: 100%;
        height: 115px;
        background: rgba(0, 0, 0, 0.5);
        position: absolute;
        top: 45px;
        left: 0;
        .detail-name{
            margin: 10px;
            border: 2px solid #FFFFFF;
            color: #FFFFFF;
            height: 94px;
            text-align: center;
            line-height: 94px;
            font-size: 22px;
            font-family: PingFangSC-Bold, PingFang SC;
            font-weight: bold;
        }
        .detail-long{
          &>p{
            width: 350px;
            line-height: 31px;
            margin-top: 16px;
          }
        }
    }
    .detail-warp.app{
      top: 0;
    }
    .detail-count{
      width: 100%;
      height: 42px;
      background-color: #FFFFFF;
      text-align: center;
      border-bottom: 1px solid #EEEEEE;
      position: relative;
      .count-num{
        line-height: 42px;
        font-size: 17px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #1E1F22;
      }
      .count-left{
        width: 43px;
        border-bottom: 2px solid #E2E2E2;
        position: absolute;
        left: 93px;
        top: 20px;
      }
      .count-right{
        width: 43px;
        border-bottom: 2px solid #E2E2E2;
        position: absolute;
        right: 93px;
        top: 20px;
      }
    }
    .home-header{
      position: fixed;
      top: 0;
      width: 100%;
      z-index: 9;
    }
    .top-banner{
      width: 100%;
      margin-top: 45px;
      height: 115px;
    }
    .top-banner.app{
      margin-top: 0;
    }
    .list-content{
      background-color: #F5F5F5;
      margin-bottom: 14px;
      .list-item{
        position: relative;
        border-bottom: 1px solid #EEEEEE;
        .main-img{
          width: 100%;
          box-shadow: 0px 1px 7px 0px rgba(0,0,0,0.1);
          border-radius: 12px 12px 0 0;
        }
        .main-txt{
          background-color: #FFFFFF;
          padding: 15px;
          .title{
            font-size: 17px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #333333;
            line-height: 17px;
            text-shadow: 0px 1px 7px rgba(0, 0, 0, 0.1);
            height: 19px;
            line-height: 19px;
            border-left: 3px solid #2F7BFF;
            padding-left: 10px;
            display: -webkit-box;
        　　-webkit-box-orient: vertical;
        　　-webkit-line-clamp: 1;
        　　overflow: hidden;
          }
          .description{
            margin-top: 12px;
            margin-bottom: 13px;
            font-size: 10px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #888888;
            line-height: 17px;
            text-shadow: 0px 1px 7px rgba(0, 0, 0, 0.1);
            display: -webkit-box;
        　　-webkit-box-orient: vertical;
        　　-webkit-line-clamp: 2;
        　　overflow: hidden;
          }
          .view-count{
            position: relative;
            text-align: right;
            font-size: 9px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #888888;
            line-height: 10px;
            text-shadow: 0px 1px 7px rgba(0, 0, 0, 0.1);
            height: 10px;
            &>p{
                display: inline-block;
            }
            .view-left{
                float: left;
                img{
                    width: 10px;
                    margin-right: 4px;
                    position: absolute;
                    top: 1px;
                }
            }
            .view-right{
                float: right;
            }
            span{
              display: inline-block;
              padding-left: 14px;
            }
            img{
              width: 10px;
              margin-right: 4px;
              position: absolute;
              top: -1px;
            }
          }
        }
      }
    }
    .to-top{
      width: 34px;
      position: fixed;
      right: 10px;
      bottom: 55px;
    }
    .to-index{
      width: 122px;
      position: fixed;
      right: 10px;
      bottom: 73px;
    }
    .flooter-btn{
        width: 100%;
        height: 62px;
        background-color: #FFFFFF;
        border-top: 1px solid #EEEEEE;
        position: fixed;
        left: 0;
        bottom: 0;
        .btn{
            width: 342px;
            height: 46px;
            background: #2177FF;
            border-radius: 2px;
            font-size: 17px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #FFFFFF;
            line-height: 46px;
            text-align: center;
            position: absolute;
            top: 8px;
            left: 17px;
        }
    }
    #contact{
        bottom: 117px !important;
    }
  }

</style>



// WEBPACK FOOTER //
// src/view/collection/detail.vue